document.addEventListener("DOMContentLoaded", () => {
  try {
    const roots = document.querySelectorAll("[data-ir-pp]");
    if (!roots.length) return;

    roots.forEach((root) => {
      if (!root) return;

      const card = root.querySelector("[data-ir-pp-card]");
      const btnClose = root.querySelector("[data-ir-pp-close]");
      const btnPlay = root.querySelector("[data-ir-pp-play]");
      const tab = root.querySelector("[data-ir-pp-tab]");
      const video = root.querySelector(".ir-pp__video");
      const iframe = root.querySelector(".ir-pp__iframe");
      const ctaButton = root.querySelector("[data-ir-pp-cta]");

      if (!card) return;

      let closed = false;
      let expanded = false;

      const baseIframeSrc = iframe ? iframe.getAttribute("src") || "" : "";

      const forcePlayingClass = () => {
        root.classList.add("is-playing");
        card.classList.add("is-playing");
      };
      forcePlayingClass();

      const showTab = () => root.classList.add("is-tab-visible");
      const hideTab = () => root.classList.remove("is-tab-visible");

      // --- Build modal overlay ---
      const modal = document.createElement("div");
      modal.className = "ir-pp__modal";
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-label", "Video player");
      modal.style.cssText = [
        "display:none",
        "position:fixed",
        "inset:0",
        "z-index:99999",
        "background:rgba(0,0,0,0.82)",
        "align-items:center",
        "justify-content:center",
        "backdrop-filter:blur(4px)",
        "-webkit-backdrop-filter:blur(4px)"
      ].join(";");

      const modalInner = document.createElement("div");
      modalInner.className = "ir-pp__modal-inner";
      modalInner.style.cssText = [
        "position:relative",
        "width:min(720px,90vw)",
        "aspect-ratio:1/1",
        "border-radius:18px",
        "overflow:hidden",
        "background:#000",
        "box-shadow:0 32px 80px rgba(0,0,0,0.6)"
      ].join(";");

      const modalClose = document.createElement("button");
      modalClose.type = "button";
      modalClose.setAttribute("aria-label", "Close expanded video");
      modalClose.style.cssText = [
        "position:absolute",
        "top:14px",
        "right:14px",
        "width:38px",
        "height:38px",
        "border-radius:999px",
        "border:1px solid rgba(255,255,255,0.3)",
        "background:rgba(0,0,0,0.55)",
        "color:#fff",
        "display:inline-flex",
        "align-items:center",
        "justify-content:center",
        "z-index:10",
        "cursor:pointer"
      ].join(";");
      modalClose.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M18.3 5.7L12 12l6.3 6.3-1.4 1.4L10.6 13.4 4.3 19.7 2.9 18.3 9.2 12 2.9 5.7 4.3 4.3l6.3 6.3 6.3-6.3 1.4 1.4z" fill="currentColor"/></svg>';

      // Modal video container
      const modalMedia = document.createElement("div");
      modalMedia.style.cssText = "width:100%;height:100%;";

      modalInner.appendChild(modalMedia);
      modalInner.appendChild(modalClose);
      modal.appendChild(modalInner);
      document.body.appendChild(modal);

      // --- Expand: open modal with video ---
      const expandCard = () => {
        if (expanded) return;
        expanded = true;

        // Clone the media content into modal
        modalMedia.innerHTML = "";
        if (iframe) {
          const src = baseIframeSrc;
          const hasQ = src.includes("?");
          const modalIframe = document.createElement("iframe");
          modalIframe.style.cssText = "width:100%;height:100%;display:block;border:0;";
          modalIframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
          modalIframe.setAttribute("allowfullscreen", "");
          modalIframe.setAttribute("title", "Video player");
          modalIframe.src = src + (hasQ ? "&" : "?") + "autoplay=1";
          modalMedia.appendChild(modalIframe);
        } else if (video) {
          const modalVideo = document.createElement("video");
          modalVideo.style.cssText = "width:100%;height:100%;display:block;object-fit:contain;";
          modalVideo.setAttribute("playsinline", "");
          modalVideo.setAttribute("controls", "");
          // Copy sources
          Array.from(video.querySelectorAll("source")).forEach(s => {
            const ns = document.createElement("source");
            ns.src = s.src;
            ns.type = s.type;
            modalVideo.appendChild(ns);
          });
          if (!modalVideo.querySelector("source") && video.src) {
            const ns = document.createElement("source");
            ns.src = video.src;
            modalVideo.appendChild(ns);
          }
          modalMedia.appendChild(modalVideo);
          modalVideo.play().catch(() => {});
        }

        modal.style.display = "flex";
        document.body.style.overflow = "hidden";
        // Pause small card video
        if (video && !video.paused) video.pause();
      };

      // --- Collapse: close modal ---
      const collapseCard = () => {
        if (!expanded) return;
        expanded = false;
        modal.style.display = "none";
        document.body.style.overflow = "";
        // Clear modal content to stop playback
        modalMedia.innerHTML = "";
        // Resume small card autoplay
        if (iframe) {
          const src = baseIframeSrc;
          const hasQ = src.includes("?");
          iframe.setAttribute("src", src + (hasQ ? "&" : "?") + "autoplay=1&mute=1");
        } else if (video) {
          video.muted = true;
          video.play().catch(() => {});
        }
        forcePlayingClass();
      };

      modalClose.addEventListener("click", (e) => {
        e.stopPropagation();
        collapseCard();
      });
      modal.addEventListener("click", (e) => {
        if (e.target === modal) collapseCard();
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && expanded) collapseCard();
      });

      // Click on floating card media area = expand
      const mediaArea = card.querySelector(".ir-pp__media");
      if (mediaArea) {
        mediaArea.style.cursor = "pointer";
        mediaArea.addEventListener("click", (e) => {
          // Don't expand if clicking play button
          if (e.target.closest("[data-ir-pp-play]")) return;
          expandCard();
        });
      }

      // --- Move card to body immediately ---
      const moveCardToBody = () => {
        if (!card.parentElement || card.parentElement === document.body) return;
        document.body.appendChild(card);
        card.classList.add("is-floating");
        forcePlayingClass();
      };
      moveCardToBody();

      // --- Autoplay small card ---
      const autoplay = () => {
        if (iframe) {
          const src = baseIframeSrc;
          if (!src) return;
          const hasQ = src.includes("?");
          iframe.setAttribute("src", src + (hasQ ? "&" : "?") + "autoplay=1&mute=1");
        } else if (video) {
          video.muted = true;
          const tryPlay = () => { video.play().catch(() => {}); };
          if (video.readyState >= 2) tryPlay();
          else video.addEventListener("canplay", tryPlay, { once: true });
        }
        forcePlayingClass();
      };
      autoplay();

      // --- Play button on small card ---
      if (btnPlay) {
        btnPlay.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (iframe) { autoplay(); return; }
          if (!video) return;
          if (video.paused) video.play().catch(() => {});
          else video.pause();
          forcePlayingClass();
        });
      }

      if (video) {
        video.addEventListener("play", forcePlayingClass);
        video.addEventListener("pause", forcePlayingClass);
        video.addEventListener("ended", forcePlayingClass);
      }

      // --- Close small card ---
      if (btnClose) {
        btnClose.addEventListener("click", (e) => {
          e.stopPropagation();
          closed = true;
          if (iframe) iframe.src = "";
          else if (video) { try { video.pause(); } catch (_) {} }
          card.style.display = "none";
          showTab();
        });
      }

      // --- Side tab reopen ---
      const openFromTab = () => {
        closed = false;
        hideTab();
        card.style.display = "";
        forcePlayingClass();
        autoplay();
      };
      if (tab) {
        tab.addEventListener("click", openFromTab);
        tab.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") openFromTab();
        });
      }

      // --- CTA scroll ---
      if (ctaButton) {
        ctaButton.addEventListener("click", (e) => {
          const href = ctaButton.getAttribute("href");
          const scrollTarget = ctaButton.getAttribute("data-scroll-target");
          if ((!href || href === "/collections/all" || href === "#") && scrollTarget) {
            e.preventDefault();
            const target = document.getElementById(scrollTarget)
              || document.querySelector(`[data-section-id*="${scrollTarget}"]`)
              || document.querySelector(`section[class*="${scrollTarget}"], section[id*="${scrollTarget}"]`);
            if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }

      // --- IntersectionObserver (for reveal animations only) ---
      // const io = new IntersectionObserver(
      //   (entries) => entries.forEach((e) => root.classList.toggle("is-inview", e.isIntersecting)),
      //   { threshold: 0.18 }
      // );
      // io.observe(root);


      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              root.classList.add("is-inview");

              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.18
        }
      );

io.observe(root);
    });
  } catch (error) {
    console.error("Error initializing IR Proof Purchase:", error);
  }
});